// @flow

export type ProposalSummaryData = {
  "created": number,
  "createdTotalCost": number,
  "sent": number,
  "sentTotalCost": number,
  "accepted": number,
  "acceptedTotalCost": number,
}

export default class PropositionSummary {
  created: number;
  createdTotalCost: number;
  sent: number;
  sentTotalCost: number;
  accepted: number;
  acceptedTotalCost: number;

  constructor(data: { [string]: any }) {
    this.created = data.created;
    this.createdTotalCost = data.createdTotalCost;
    this.sent = data.sent;
    this.sentTotalCost = data.sentTotalCost;
    this.accepted = data.accepted;
    this.acceptedTotalCost = data.acceptedTotalCost;
  }

  static parse(data: ProposalSummaryData) {
    return new PropositionSummary({
      created: data.created,
      createdTotalCost: data.createdTotalCost,
      sent: data.sent,
      sentTotalCost: data.sentTotalCost,
      accepted: data.accepted,
      acceptedTotalCost: data.acceptedTotalCost,
    });
  }
}



// WEBPACK FOOTER //
// ./src/statsradio/modules/salesDashboard/domain/PropositionSummary.js